import App from 'app/app.js';
import LtSelectionDrawerCtrl from 'app/directive/LtSelectionDrawerCtrl.js';

function LtSaveAlertCtrl($scope, $timeout, $rootScope) {
  var self = this;
  this.isOrderEditPage = $scope.isOrderEditPage;

  LtSelectionDrawerCtrl.call(this, $scope, $timeout);

  this.navigation = function () {
    $scope.navigateUser();
  };

  $rootScope.$on('enhancements', function () {
    self.isEnhancementPage = !self.isEnhancementPage;
  });
}

App.controller('LtSaveAlertCtrl', ['$scope', '$timeout', '$rootScope', LtSaveAlertCtrl]);
